var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('view-card',{attrs:{"headline":"기본계약사항"}},[_c('div',{staticClass:"contract-terms-basic-box"},[_vm._v(_vm._s(_vm.contractContent))])])}
var staticRenderFns = []

export { render, staticRenderFns }